import { computed } from 'vue';

export default function useIsElectronApp() {
  const isElectronApp = computed((): boolean => navigator?.userAgent.indexOf('Electron') >= 0);

  return {
    isElectronApp,
  };
}
